import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import { EvaluationFormListItemFragment } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useDeleteEvaluationForm } from 'modules/ats/hooks/evaluationForms/useDeleteEvaluationForm'

interface Props {
  evaluationForm: EvaluationFormListItemFragment
  onClose: () => void
}

export const DeleteEvaluationForm = ({ evaluationForm, onClose }: Props) => {
  const { deleteEvaluationForm, loading: isDeleting } = useDeleteEvaluationForm(evaluationForm)
  const jobPostingId = evaluationForm.atsJobPostingId

  const onDelete = async () => {
    const result = await deleteEvaluationForm()

    const handled = handleResult(result, () => undefined)
    setFlashMessage(handled.success)
  }

  const setFlashMessage = (success: boolean) => {
    const type = success ? 'correct' : 'wrong'
    const message = success
      ? i18n.t('ats.evaluation_forms.delete.success')
      : i18n.t('ats.evaluation_forms.delete.error')

    app.setFlash({
      type: type,
      message: message,
      time: 2000,
    })
  }

  return (
    <Modal
      illustration="alert"
      title={
        !!jobPostingId
          ? i18n.t('ats.evaluation_forms.delete.title')
          : i18n.t('ats.evaluation_forms.delete_template.title')
      }
      description={
        !!jobPostingId
          ? i18n.t('ats.evaluation_forms.delete.description')
          : i18n.t('ats.evaluation_forms.delete_template.description')
      }
      onSubmit={onDelete}
      onClose={onClose}
      footer={
        <>
          <Button type="secondary" onClick={onClose} disabled={isDeleting}>
            {i18n.t('common.cancel')}
          </Button>
          <Button submit disabled={isDeleting}>
            {!!jobPostingId
              ? i18n.t('ats.evaluation_forms.delete.submit')
              : i18n.t('ats.evaluation_forms.delete_template.submit')}
          </Button>
        </>
      }
    />
  )
}
